export const removeParagraph = (str = '') =>
  (str || '').replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '')

export const nl2br = (str: string) => {
  return str?.replace(/(\r\n|\n\r|\r|\n)/g, '<br />')
}

export const truncateText = (text: string, maxLength: number = 200): string => {
  if (!text || text.length <= maxLength) {
    return text
  }

  // Trova l'ultimo spazio prima della lunghezza massima
  const truncated = text.substring(0, maxLength)
  const lastSpaceIndex = truncated.lastIndexOf(' ')

  // Se non c'è spazio, tronca alla lunghezza massima
  if (lastSpaceIndex === -1) {
    return truncated + '...'
  }

  // Tronca all'ultimo spazio e aggiungi "..."
  return truncated.substring(0, lastSpaceIndex) + '...'
}

export const formatPrice = (value: string | number) => {
  const num = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value
  if (isNaN(num)) return `0,00 €`
  return `${num.toFixed(2).replace('.', ',')} €`
}

export const truncateFileName = (fileName: string, maxLength: number = 25): string => {
  if (fileName.length <= maxLength) return fileName

  const lastDotIndex = fileName.lastIndexOf('.')
  const hasExtension = lastDotIndex > 0 && lastDotIndex > fileName.length - 6

  if (hasExtension) {
    const extension = fileName.slice(lastDotIndex)
    const nameWithoutExt = fileName.slice(0, lastDotIndex)
    const availableLength = maxLength - extension.length - 3

    if (availableLength <= 4) {
      return fileName.slice(0, maxLength - 3) + '...'
    }

    const startLength = Math.ceil(availableLength * 0.6)
    const endLength = availableLength - startLength

    return (
      nameWithoutExt.slice(0, startLength) + '...' + nameWithoutExt.slice(-endLength) + extension
    )
  }

  return fileName.slice(0, maxLength - 3) + '...'
}
